<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate>

      <div class="p-grid">
          <div class="p-col-6">
              <h2>{{ t('common.labels.contents') }}</h2>
          </div>
          <div class="p-col-6 p-text-right">
            <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
          </div>
      </div>

      <div class="p-grid p-fluid">
          <div class="p-col-12">
            <app-form-control [cid]="'identifier'" [control]="form.get('identifier')" [type]="'input'" [label]="t('common.labels.identifier')"></app-form-control>
            <app-form-control [cid]="'type'" [control]="form.get('type')" [type]="'select'" [label]="t('common.labels.type')" [options]="optionsTypes"></app-form-control>
            <app-form-control [cid]="'description'" [control]="form.get('description')" [type]="'textarea'" [label]="t('common.labels.description')"></app-form-control>
          </div>
      </div>

  </form>
</ng-container>
